import { create } from "zustand";

export type UseLoadingStateStore = {
  isFetching: boolean;
  isLoaderLine: boolean;
  isLoaderXCircle: boolean;
  setIsFetching: (isFetching: boolean) => void;
  setIsLoaderXCircle: (isLoaderXCircle: boolean) => void;
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
  fetchingNodeIds: Set<string>;
  addFetchingNodeId: (id: string) => void;
  removeFetchingNodeId: (id: string) => void;
};

const useLoadingStateStore = create<UseLoadingStateStore>((set) => ({
  isFetching: false,
  isLoaderXCircle: true,
  isLoaderLine: false,
  setIsFetching: (isFetching) => set({ isFetching }),
  setIsLoaderXCircle: (isLoaderXCircle) =>
    set({ isLoaderXCircle, isLoaderLine: !isLoaderXCircle }),
  isModalOpen: false,
  setIsModalOpen: (isModalOpen) => set({ isModalOpen }),
  fetchingNodeIds: new Set<string>(),
  addFetchingNodeId: (id) =>
    set((state) => {
      const updatedFetchingNodeIds = new Set(state.fetchingNodeIds);
      updatedFetchingNodeIds.add(id);
      return {
        fetchingNodeIds: updatedFetchingNodeIds,
        isFetching: updatedFetchingNodeIds.size > 0,
      };
    }),
  removeFetchingNodeId: (id) =>
    set((state) => {
      const updatedFetchingNodeIds = new Set(state.fetchingNodeIds);
      updatedFetchingNodeIds.delete(id);
      return {
        fetchingNodeIds: updatedFetchingNodeIds,
        isFetching: updatedFetchingNodeIds.size > 0,
      };
    }),
}));

export const useIsFetching = () =>
  useLoadingStateStore((state) => state.isFetching);
export const useIsLoaderLine = () =>
  useLoadingStateStore((state) => state.isLoaderLine);
export const useIsLoaderXCircle = () =>
  useLoadingStateStore((state) => state.isLoaderXCircle);
export const useIsModalOpen = () =>
  useLoadingStateStore((state) => state.isModalOpen);
export const useSetIsFetching = () =>
  useLoadingStateStore((state) => state.setIsFetching);
export const useSetIsLoaderXCircle = () =>
  useLoadingStateStore((state) => state.setIsLoaderXCircle);
export const useSetIsModalOpen = () =>
  useLoadingStateStore((state) => state.setIsModalOpen);
export const useIsNodeFetching = (id: string | null) =>
  useLoadingStateStore((state) => (id ? state.fetchingNodeIds.has(id) : false));

export const getSetIsLoaderXCircle = () =>
  useLoadingStateStore.getState().setIsLoaderXCircle;
export const getAddFetchingNodeId = () =>
  useLoadingStateStore.getState().addFetchingNodeId;
export const getRemoveFetchingNodeId = () =>
  useLoadingStateStore.getState().removeFetchingNodeId;
